
import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Block } from "../../components/Component";
import { useForm } from "react-hook-form";

import { listWebContactAPI } from "../../api/master/indes";

import { toast } from "react-toastify";
import useLogout from "../../hooks/useLogout";
import Table from "../../MyComp/UI/DataTable/Table";

const CustomerInquiries = () => {
  const {
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      isLoading: false,
    },
  });

  const logout = useLogout();

  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState([]);

  const isLoading = watch("isLoading");

  // ================= INIT =================
  useEffect(() => {
    getContact();
  }, []);

  // ================= GET CONTACT =================
  const getContact = () => {
    setValue("isLoading", true);

    listWebContactAPI()
      .then((res) => {
        if (res.data.status === true) {
          console.log("API RESPONSE:", res.data);

          setData(res.data.data || []);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message || "Something went wrong"
        );
      })
      .finally(() => {
        setValue("isLoading", false);
      });
  };

  // ================= FORMAT DATA =================
  const contactData = Array.isArray(data)
    ? data
    : Object.values(data || {});

  const formattedData = contactData.map((item) => ({
    id: item?.id,
    name: item?.name || "-",
    email: item?.email || "-",
    mobile: item?.mobile || "-",
    country: item?.country || "-",
    subject: item?.subject || "-",
    message: item?.message || "-",
    status: item?.status || "-",
    createdAt: item?.createdAt
      ? new Date(item.createdAt).toLocaleString()
      : "-",
  }));

  return (
    <>
      <Head title={"Customer Inquiries"} />

      <Content>
        <Block>
          <Table
            title="Customer Inquiries List"
            data={formattedData}
            columns={[
              {
                key: "name",
                label: "Name",
              },
              {
                key: "email",
                label: "Email",
              },
              {
                key: "mobile",
                label: "Mobile",
              },
              {
                key: "country",
                label: "Country",
              },
              {
                key: "subject",
                label: "Subject",
              },
              {
                key: "message",
                label: "Message",
              },
              {
                key: "status",
                label: "Status",
              },
              {
                key: "createdAt",
                label: "Created At",
              },
            ]}
            nameColumn="name"
            addButton={false}
            medicineStatus={true}
            statusAction={false}
          />
        </Block>
      </Content>
    </>
  );
};

export default CustomerInquiries;

